import { render, staticRenderFns } from "./FormControlTypeUrl.vue?vue&type=template&id=73a43010&scoped=true"
import script from "./FormControlTypeUrl.vue?vue&type=script&lang=js"
export * from "./FormControlTypeUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a43010",
  null
  
)

export default component.exports